<template>
  <div>
    <div class="row gutter-sm" v-for="(bankDetail, index) in bankDetails" :key="index">
      <div :class="[bankDetailsNotEmpty ? 'col-11' : 'col-12']">
        <bank-details-input
          @input="updateBankDetails($event, index)"
          :value="bankDetail"
          :id="index"
          :expanded="bankDetailsNotEmpty"
          :label="label"
          :hideLabel="hideLabel"
          :showIcon="showIcon"
        />
      </div>

      <div v-show="bankDetailsNotEmpty" class="col-1 text-right">
        <q-btn flat dense icon="remove_circle" color="light" class="q-mt-lg" @click="clearBankDetails(index)"/>
      </div>
    </div>
    <div class="row justify-end">
      <q-btn flat dense
             v-show="bankDetailsNotEmpty"
             @click="addBankDetails"
             :label="$t('additional_bank_details')"
             :class="showControls ? 'q-mr-xl' : ''"
      />
    </div>
  </div>
</template>

<script>
  import BankDetailsInput from './BankDetailsInput'
  import CustomerBankDetails from 'src/utils/SubResources/CustomerBankDetails'
  import { isEqual } from 'lodash'

  export default {
    inject: ['$validator'],

    props: {
      /**
       * Used for v-model
       */
      value: {
        type: Array,
        required: true
      },

      /**
       * Indicate if the label input should be visible
       */
      label: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the label of the bank details line field should be visible
       */
      hideLabel: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the field icon should be visibile
       */
      showIcon: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        bankDetails: this.value
      }
    },

    computed: {
      showControls () {
        return this.bankDetails.length > 1
      },

      bankDetailsNotEmpty () {
        return !this.isEmptyBankDetails(this.bankDetails[0])
      }
    },

    methods: {
      updateBankDetails (value, index) {
        this.bankDetails.splice(index, 1, value)

        this.createDefaultBankDetails()

        this.emitBankDetails()
      },

      addBankDetails () {
        this.bankDetails.push(CustomerBankDetails.empty())
      },

      clearBankDetails (index) {
        this.bankDetails.splice(index, 1)
      },

      showRemoveButton (index) {
        return index < this.bankDetails.length - 1
      },

      isEmptyBankDetails (bankDetails) {
        return isEqual(bankDetails, CustomerBankDetails.empty())
      },

      bankDetailsIsExpanded (index) {
        return index < this.bankDetails.length - 1
      },

      emitBankDetails () {
        this.$emit('input', this.bankDetails)
      },

      createDefaultBankDetails () {
        if (this.bankDetails.length === 0) {
          this.addBankDetails()
        }
      }
    },

    created () {
      this.createDefaultBankDetails()
    },

    watch: {
      value: {
        handler: function (newBankDetails) {
          this.bankDetails = newBankDetails
          this.createDefaultBankDetails()
        },
        deep: true
      }
    },

    components: {
      BankDetailsInput
    }
  }
</script>
